import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const Container = styled.div`
  height: 100%;
  width: 100%;
  background-size: cover;
`

export const GreenContainer = styled.div`
  height: 100%;
  width: 100%;
  background-color: ${colors.primary};
  opacity: 0.96;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  box-sizing: border-box;
  padding: 2% 0;
`

export const CardContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  width: 50vw;
  max-width: 324px;
`

export const Box = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
`
